module.exports = __webpack_public_path__ + "img/qrcode_ios.b6226e3b.png";